import { IParameterGroup } from '@/pages/Parameters/parameters.types.ts'
import { CSSProperties, useMemo } from 'react'
import { useRecoilValue } from 'recoil'
import parameterGroupsAtom from '@/pages/Parameters/parameterGroups.atom.ts'
import TreeGroupDropdown from '@/shared/Tree/components/TreeGroupDropdown'
import { ITreeGroup } from '@/shared/Tree/tree.types.ts'

interface IProps {
  value: IParameterGroup['id']
  name: string
  onChange: (val: IParameterGroup['id'], name: string) => void
  title?: string
  wrapperStyle?: CSSProperties
}

const ParameterGroupDropdown = (props: IProps) => {
  const parameterGroups = useRecoilValue(parameterGroupsAtom).items

  const treeGroups: ITreeGroup<IParameterGroup, number>[] = useMemo(() => {
    if (!parameterGroups.length) return []

    return parameterGroups.map((g) => ({ id: g.id, parentId: g.parentId, data: g, type: 'none' }))
  }, [parameterGroups])

  return (
    <TreeGroupDropdown
      name={props.name}
      wrapperStyle={props.wrapperStyle}
      optionNameGetter={(group: IParameterGroup) => group.name}
      title={props.title || 'Выберите группу'}
      options={treeGroups as any}
      onSelect={props.onChange}
      selectedOption={props.value}
    />
  )
}

export default ParameterGroupDropdown
